<app-modal title="API_INTERFACES.ADD_CUSTOMER" [loading]="loading" (submitClicked)="submit()" [closeText]="'CANCEL'"
           [submitText]="'SAVE'">
  <app-api-interface-customer-form [apiInterface]="apiInterface" (formGroupOutput)="formGroup = $event"></app-api-interface-customer-form>
</app-modal>
